export function formatUsdMillions(
  value: number | null,
  unavailableLabel = 'Unavailable'
) {
  if (value === null) return unavailableLabel
  const sign = value < 0 ? '−' : ''
  return `${sign}$${Math.abs(value).toFixed(1)}M`
}

export function formatPercentage(
  value: number | null,
  unavailableLabel = 'Unavailable'
) {
  if (value === null) return unavailableLabel
  const sign = value > 0 ? '+' : value < 0 ? '−' : ''
  return `${sign}${Math.abs(value * 100).toFixed(1)}%`
}
